import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";

import axios from "axios";

import { Wrapper, Modal, Button } from "./styles";
import texts from "../../../utils/texts";
import consts from "../../../utils/config";

const HolidayAlert: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [holiday, setHoliday] = useState({
    holiday: false,
    text: "",
    name: "",
  });

  const closeModal = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    axios.get(consts.getHolidaysUrl()).then((resp) => {
      let data = resp.data.results[0];
      console.log(data);
      if (resp.data.results.length > 0) {
        setHoliday({
          holiday: true,
          name: data.name,
          text: data.text,
        });
      } else {
        setHoliday({
          holiday: false,
          name: "",
          text: "",
        });
      }
    });
  }, []);

  // Check if the alert was already been seen
  useEffect(() => {
    if (!checked) {
      setIsVisible(true);
    }

    setChecked(true);
  }, [checked]);

  return (
    <>
      {isVisible && holiday.holiday ? (
        <Wrapper>
          <Modal>
            <div className="modal-header">
              <h2>{holiday.name}</h2>
              <Button onClick={closeModal}>
                <span>{texts.home.modal_alert.exit_button}</span>
                <div className="button-icon">
                  <FaTimes />
                </div>
              </Button>
            </div>
            <div className="modal-content">
              <p>{holiday.text}</p>
            </div>
          </Modal>
        </Wrapper>
      ) : null}
    </>
  );
};

export default HolidayAlert;
